/**
 * Generic notification
 */

var component_notification = function(args) {

  // setup args
  var shouldShowNotification     = args.shouldShowNotification,
      afterClosingNotification   = args.afterClosingNotification,
      afterShowingNotification   = args.afterShowingNotification,
      notificationHTML           = args.notificationHTML,
      notificationClass          = args.notificationClass;


  // validate
  if (typeof notificationHTML !== 'function' || typeof shouldShowNotification !== 'function') {
    console.log('Invalid notification args');
    return;
  }

  const addFooterPadding = function() {

    var notifications = document.querySelector('.js-notifications');
    var safeArea = document.querySelector('.js-notification-safearea');
    if (notifications && safeArea) {
      if (notifications.offsetHeight > 16) {
        safeArea.style.height = notifications.offsetHeight + 'px';
      } else {
        safeArea.style.height = 0;
      }
    }

  };

  // tasks to open menu visually
  const insertNotification = function() {

    var container = document.querySelector('.js-notifications');
    if (container) {
      var notification = document.createElement('div');
      notification.classList.add('notification');
      notification.classList.add(notificationClass());

      var notificationControl = document.createElement('div');
      notificationControl.classList.add('notification__control');

      var notificationControlButton = document.createElement('button');
      notificationControlButton.innerHTML = '<span><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13 4V11H20V13H13V20H11V13H4V11H11V4H13Z" /></svg></span>';

      notificationControl.appendChild(notificationControlButton);
      notification.appendChild(notificationControl);

      var notificationContent = document.createElement('div');
      notificationContent.classList.add('notification__content');
      notificationContent.innerHTML = notificationHTML();
      notification.appendChild(notificationContent);

      container.appendChild(notification);

      if (notificationClass() && document.querySelector('.' + notificationClass() + ' button')) {
        document.querySelector('.' + notificationClass() + ' button').addEventListener('click', function(e) {

          e.currentTarget.closest('.notification').classList.add('notification--dismissed');
          afterClosingNotification();
          addFooterPadding();
          setTimeout(function() {
            addFooterPadding();
          }, 250);
        });
      }

    }

  };

  // tasks to close menu visually
  const closeNotification = () => {

  };

  if (shouldShowNotification()) {
    insertNotification();
    addFooterPadding();
  }

  window.addEventListener('resize', function(e) {
    addFooterPadding();
  })

  // make the call chainable
  return this;

};
